/*
    工場コードを選択するリスト
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export type PlantCodeSelectProp = {
  // ラベル
  label: string;
  // 工場コード
  selectPlantCode: string;
  // 加工コードが選択された場合のイベント処理
  handlePlantCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  // 値を変更した状態の表示か（枠線の色を変更）
  isValueChangeState?: boolean;
};

export const PlantCodeSelect: React.FC<PlantCodeSelectProp> = ({
  label,
  selectPlantCode,
  handlePlantCodeChange,
  isValueChangeState = false,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "select-plant-code-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  // 工場・加工・機械マスタデータ
  const plant_proc_mach = useSelector(
    (state: RootState) => state.procs.plantProcMach
  );
  const plantCodeOptions = plant_proc_mach.reduce((acc, item) => {
    if (!acc.some((existing) => existing.code === item.plant_code)) {
      acc.push({
        code: item.plant_code,
        name: item.plant_name,
      });
    }
    return acc;
  }, [] as { code: string; name: string }[]);

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <select
        id={id}
        onChange={handlePlantCodeChange}
        value={selectPlantCode}
        className={
          isValueChangeState
            ? "value-change-state-select input-110"
            : "input-110"
        }
      >
        <option value="">-</option>
        {plantCodeOptions.map(({ code, name }, index) => (
          <option key={index} value={code}>{`${code}: ${name}`}</option>
        ))}
      </select>
    </>
  );
};
